'use client'

import Grid from "@mui/material/Unstable_Grid2"
import { useTranslation } from "@theme/base/contexts"
import { useFormikContext } from "formik"
import SideFilters, { SideFilterSectionItemProps } from "@theme/base/templates/Orders/SideFilters"
import { DeliveryNoteSearchRequestInputWithMonth } from "@theme/base/templates/DeliveryNotes/DeliveryNotes"

const DeliveryNotesLeftFilters = () => {
    const { getTranslation } = useTranslation();
    const { values, setFieldValue, submitForm } = useFormikContext<DeliveryNoteSearchRequestInputWithMonth>()

    const handleOrderStatusClick = (value: string | null) => {
        setFieldValue('invoiced', value)
        submitForm()
    }

    const searchOrders: SideFilterSectionItemProps[] = [
        {
            label: getTranslation("common.all"),
            value: null,
            color: undefined,
            selected: values.invoiced === null
        },
        {
            label: getTranslation("deliverynotes.filters.isinvoiced"),
            value: 'true',
            color: 'green',
            selected: values.invoiced === 'true'
        },
        {
            label: getTranslation("deliverynotes.filters.not_isinvoiced"),
            value: 'false',
            color: 'orange',
            selected: values.invoiced === 'false'
        }
    ]

    return (
        <Grid xs pr={{ xs: 0, md: 2 }} sx={{ display: { xs: 'none', lg: 'block' } }}>
            <SideFilters
                items={searchOrders}
                title={getTranslation("deliverynotes.search")}
                onClickFunction={handleOrderStatusClick}
            />
        </Grid>
    )
}

export default DeliveryNotesLeftFilters